import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import { getProductColor } from "@scenes/pdp/utils/utils";
import { getProductBorderColor } from "@components/molecules/MatchStoneGalleryModel/Utils";
import { useState } from "react";
import { ResetButtonComponentProps } from "./types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import { useTranslation } from "react-i18next";

const ResetButtonComponent = ({ productType }: ResetButtonComponentProps) => {
  const [isHovering, setIsHovering] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const hoverColor = getProductColor(productType);
  const defaultColor = getProductBorderColor(productType);
  const { resetDefaultSlug } = useJewelryConfiguratorState();

  return (
    <ResetButtonContainer>
      <ResetButton
        onPress={() => {
          resetDefaultSlug();
        }}
        onHoverIn={() => {
          setIsHovering(true);
        }}
        onHoverOut={() => {
          setIsHovering(false);
        }}
      >
        <VDBText
          type={typography["H3-M"]}
          color={
            isHovering
              ? (theme[hoverColor as keyof DefaultTheme] as string)
              : (theme[defaultColor as keyof DefaultTheme] as string)
          }
        >
          {t("productDetailPage.reset.text", "Reset")}
        </VDBText>
        <VDBIcon
          color={
            isHovering
              ? (theme[hoverColor as keyof DefaultTheme] as string)
              : (theme[defaultColor as keyof DefaultTheme] as string)
          }
          size={24}
          variant={IconsVariant.VDBCustom}
          name={VDBIcons.ARROW_RESET}
        />
      </ResetButton>
      <Spacer size={SpaceType.Basic} />
    </ResetButtonContainer>
  );
};

const ResetButtonContainer = styled.View`
  height: 40px;
`;

const ResetButton = styled.Pressable`
  flex-direction: row;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: ${SpaceType.Basic}px;
`;

export default ResetButtonComponent;
